import { TAB_NAMES } from "../../utils/accessMapConstants";

/**
 * Resolves FilterScope for project/collection list APIs from the active tab.
 */
export function buildListScope(activeTab, overrideActiveTab) {
  const effectiveTab =
    overrideActiveTab !== undefined ? overrideActiveTab : activeTab;
  return effectiveTab === TAB_NAMES.DISCOVERY ? "EXTERNAL" : "MY";
}
